import Service from '@ember/service'
import { tracked } from '@glimmer/tracking'

export default class SidebarService extends Service {
  @tracked activatedElementId?: string

  @tracked expandedItemId?: string

  activate = (elementId: string) => {
    this.activatedElementId = elementId
    // Any time an activate occurs, we also expand that item
    // If the item was a link rather than an expands, this should just close the other menus.
    this.expandedItemId = elementId
  }

  toggleExpand = (elementId: string) => {
    if (this.expandedItemId === elementId) {
      this.expandedItemId = undefined
    } else {
      this.expandedItemId = elementId
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    sidebar: SidebarService
  }
}
